export default {"src":"/_next/static/media/bank-document.661aa47d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};